import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader } from '../../../UiKit';
import { BlockingPopup } from '../../popups';
import { popUpClosedEvent, popUpOpenendEvent } from '../../../analytics/events';
import {
  EventType,
  FeatureName,
  MetricsForJumboEvent,
} from '../../../analytics/constants';
import getStore from '../../../store/store';
import history from '../../../history';

export const BlockingPopupWrapper = ({
  alerts = null,
  show = true,
  showBlockingPopup = () => {},
}) => {
  const [modalContent, setModalContent] = useState(null);
  const store = getStore(history);
  const state = store.getState();
  const { ordersState = {} } = state;

  useEffect(() => {
    if (!show) return;
    popUpOpenendEvent({
      event_type: EventType.SHOWN,
      feature_name: FeatureName.ALERTS,
      [MetricsForJumboEvent.customer_id]: ordersState.customer_id,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  useEffect(() => {
    removeExpiredModals(alerts);
    validatePopup(alerts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alerts]);

  const getStoredItems = () =>
    localStorage && JSON.parse(localStorage.getItem('blocking_modals'));
  const setItems = (modals = []) =>
    localStorage &&
    localStorage.setItem('blocking_modals', JSON.stringify(modals));

  const removeExpiredModals = (items) => {
    const ids = [];
    items.forEach((item) => ids.push(item.id));
    let storedItems = getStoredItems();
    const filteredItems =
      storedItems && storedItems.filter((item) => ids.includes(item.id));
    setItems(filteredItems);
  };

  const validateTime = (item) => {
    let currentTime = Date.now();
    let diff = currentTime - item.viewed_time;
    if (diff > item.interval * 1000) {
      return item;
    }
  };

  const getModalFromApi = (items, storedItems) => {
    const ids = [];
    storedItems && storedItems.forEach((item) => ids.push(item.id));
    const modals = items && items.filter((item) => !ids.includes(item.id));
    return modals;
  };

  const validatePopup = (items) => {
    if (!items?.length) return null;
    // if localstorage already have items
    let storedItems = getStoredItems();
    let eligibleModals =
      storedItems?.length > 0 ? storedItems.filter(validateTime) : [];
    if (!eligibleModals?.length) {
      eligibleModals = getModalFromApi(items, storedItems);
    }
    if (eligibleModals?.length) setModalContent(eligibleModals[0]);
  };

  const setItem = (item) => {
    const modals = getStoredItems();
    const filteredItems =
      modals && modals.filter((modal) => modal.id !== item.id);
    if (item) {
      filteredItems && filteredItems.push(item);
      setItems(filteredItems);
    }
  };

  const acknowledgePopup = (item) => {
    item['viewed_time'] = Date.now();
    setItem(item);
    showBlockingPopup(false);
    popUpClosedEvent({
      event_type: EventType.CLICK,
      feature_name: FeatureName.ALERTS,
      [MetricsForJumboEvent.customer_id]: ordersState?.customer_id,
    });
  };

  if (!modalContent) return null;

  return (
    <Modal
      isVisible={show}
      titleComponent={
        <ModalHeader
          title={modalContent?.popup_content?.title || ''}
          showCloseIcon={false}
          isCentered={true}
        />
      }
      isMaxContent={true}
      showCloseIcon={false}
      maxHeight={'70vh'}
      component={
        <BlockingPopup
          content={modalContent?.popup_content}
          id={modalContent?.id}
          onSubmit={acknowledgePopup.bind(this, modalContent)}
        />
      }
    />
  );
};
